<template>
  <div v-if="home" class="home" :class="{ mobile: isMobile }">
    <FeaturedActivities
      v-if="!introEnabled || !intro"
      :isMobile="isMobile"
      :activities="home.featured_activities"
      :width="pageWidthSansScrollbar"
      @changeMobileScrollText="handleMobileScrollTextChange"
    />
    <div v-if="!introEnabled || !intro" class="flex items-center text-sm justify-center" style="height: 64px; border-top: 1px solid black">
      <router-link v-if="isMobile" to="/privacy" class="no-underline">Privacy</router-link>
    </div>
    <div
      v-if="introEnabled && intro" class="fixed w-screen h-screen pointer-events-none grid"
      :class="{logo: logo, static: staticGrid}"
    >
      <GridSix
        :scalarMode="isMobile || logo"
        :showColumns="letterCount"
        :showWords="wordCount"
        :thick="thick"
        :background="intro"
        :curved="curved"
      />
    </div>
    <div v-else class="fixed top-0 left-0 h-screen pointer-events-none" :style="`width: ${pageWidthSansScrollbar}px`">
      <GridSix
        :scalarMode="isMobile"
        :showColumns="3"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store'
import FeaturedActivities from '@/components/FeaturedActivities'
import GridSix from '@/components/GridSix'

export default {
  name: 'Home',

  components: {
    FeaturedActivities,
    GridSix
  },

  computed: {
    ...mapState(['home', 'showIntro', 'isMobile'])
  },

  data () {
    return {
      letterCount: 0,
      logo: true,
      thick: true,
      curved: true,
      wordCount: 0,
      intro: true,
      introEnabled: false,
      staticGrid: true,
      pageWidthSansScrollbar: 0,
    }
  },

  beforeRouteEnter (to, from, next) {
    next(() => {
      store.commit('DISABLE_INTRO')
    })
  },

  created () {
    window.addEventListener('resize', this.updatePageWidthSansScrollbar)
  },

  destroyed () {
    window.removeEventListener('resize', this.updatePageWidthSansScrollbar)
  },

  mounted () {
    if (this.showIntro) {
      this.introEnabled = true
      this.$emit('changeMenuVisibility', false)
    }

    this.$store.dispatch('getHome')

    if (this.introEnabled) {
      this.startIntroAnimation()
    }

    this.$emit('changeMobileScrollText', null)

    this.updatePageWidthSansScrollbar()
  },

  methods: {
    updatePageWidthSansScrollbar () {
      this.pageWidthSansScrollbar = document.documentElement.clientWidth
    },

    startIntroAnimation () {
      this.staticGrid = false

      // Show logo letters
      let timer = 700
      setTimeout(() => {
        this.letterCount = 1
      }, timer)

      timer += 700
      setTimeout(() => {
        this.letterCount = 2
      }, timer)

      timer += 700
      setTimeout(() => {
        this.letterCount = 3
      }, timer)

      timer += 700
      setTimeout(() => {
        this.curved = false
      }, timer)

      // Go large
      timer += 800
      setTimeout(() => {
        this.logo = false
        this.thick = false
      }, timer)

      timer += 1000
      setTimeout(() => {
        this.thick = false
      }, timer)

      if (!this.isMobile) {
        // Show words
        timer += 400
        setTimeout(() => {
          this.wordCount = 1
        }, timer)

        timer += 400
        setTimeout(() => {
          this.wordCount = 2
        }, timer)

        timer += 400
        setTimeout(() => {
          this.wordCount = 3
        }, timer)

        // timer += 400
        setTimeout(() => {
          this.wordCount = 4
        }, timer)

        timer += 400
        setTimeout(() => {
          this.wordCount = 5
        }, timer)

        timer += 400
        setTimeout(() => {
          this.wordCount = 6
        }, timer)
      }

      // Fade out
      timer += 400
      setTimeout(() => {
        this.wordCount = 0
      }, timer)

      timer += 400
      setTimeout(() => {
        this.$emit('changeMenuVisibility', true)
        this.$emit('changeMenuState', true)
        this.intro = false
        this.$nextTick(() => {
          this.updatePageWidthSansScrollbar()
        })
      }, timer)

      timer += 400
      setTimeout(() => {
        this.staticGrid = true
        this.updatePageWidthSansScrollbar()
      }, timer)
    },

    handleMobileScrollTextChange (text) {
      this.$emit('changeMobileScrollText', text)
    }
  }
}
</script>

<style scoped lang="stylus">
.grid {
  transition: all 0.65s ease-in-out;
  left: 0;
  top: 0;
}

.grid.static {
  transition: none;
}

.grid.logo {
  left: calc(50vw - 200px);
  top: calc(50vh - 100px);
  width: 400px;
  height: 200px;
}

.mobile .grid.logo {
  left: calc(50vw - 30vw);
  top: calc(50vh - 15vw);
  width: 60vw;
  height: 30vw;
}
</style>
